// repo/primary-care-connect/frontend/src/pages/Portal/ClinicAdmin/ClinicProfile/sections/AccessibilitySection.tsx

import React from "react";

type IdName = { id: number; name: string };

export default function AccessibilitySection(props: {
  editMode: boolean;
  accessibility: IdName[];
  accessibilityOptions: IdName[];
  draftAccessibilityIds: number[];
  setDraftAccessibilityIds: (ids: number[]) => void;
  savingAccessibility: boolean;
  accessibilityError: string | null;
  accessibilitySavedAt: string | null;
  onSaveAccessibility: () => void;
  getSelectedIdsFromMultiSelect: (e: React.ChangeEvent<HTMLSelectElement>) => number[];
  formatDateTime: (val: string | null | undefined) => string;
}) {
  const {
    editMode,
    accessibility,
    accessibilityOptions,
    draftAccessibilityIds,
    setDraftAccessibilityIds,
    savingAccessibility,
    accessibilityError,
    accessibilitySavedAt,
    onSaveAccessibility,
    getSelectedIdsFromMultiSelect,
    formatDateTime,
  } = props;

  const safeAccessibility = Array.isArray(accessibility) ? accessibility : [];
  const safeOptions = Array.isArray(accessibilityOptions) ? accessibilityOptions : [];

  return (
    <details className="ca-clinic-profile__panel" open>
      <summary className="ca-clinic-profile__summary">
        <div>
          <div className="ca-clinic-profile__sectionTitle">Accessibility</div>
          <div className="ca-clinic-profile__hint">Clinic admin-managed</div>
        </div>
      </summary>

      <div className="ca-clinic-profile__row">
        <div className="ca-clinic-profile__label">Features</div>
        <div className="ca-clinic-profile__value">
          {!editMode ? (
            <div className="ca-clinic-profile__chips">
              {safeAccessibility.length ? (
                safeAccessibility.map((x) => (
                  <span key={x.id} className="ca-clinic-profile__chip">
                    {x.name}
                  </span>
                ))
              ) : (
                <span style={{ color: "#6b7a94" }}>—</span>
              )}
            </div>
          ) : (
            <>
              <select
                className="ca-clinic-profile__multiselect"
                multiple
                value={draftAccessibilityIds.map(String)}
                disabled={savingAccessibility}
                onChange={(e) => setDraftAccessibilityIds(getSelectedIdsFromMultiSelect(e))}
              >
                {safeOptions.map((opt) => (
                  <option key={opt.id} value={String(opt.id)}>
                    {opt.name}
                  </option>
                ))}
              </select>
              <div className="ca-clinic-profile__help">
                Tip: hold Ctrl (Windows) / Cmd (Mac) to select multiple.
              </div>
            </>
          )}
        </div>
      </div>

      {accessibilityError ? (
        <div className="ca-clinic-profile__row">
          <div className="ca-clinic-profile__label"></div>
          <div className="ca-clinic-profile__value ca-clinic-profile__row-error">
            {accessibilityError}
          </div>
        </div>
      ) : null}

      {editMode ? (
        <div className="ca-clinic-profile__row">
          <div className="ca-clinic-profile__label"></div>
          <div className="ca-clinic-profile__value ca-clinic-profile__save-row">
            <button
              className="ca-clinic-profile__btn"
              onClick={onSaveAccessibility}
              disabled={savingAccessibility}
            >
              {savingAccessibility ? "Saving…" : "Save Accessibility"}
            </button>

            {accessibilitySavedAt ? (
              <span className="ca-clinic-profile__savedAt">
                Saved {formatDateTime(accessibilitySavedAt)}
              </span>
            ) : null}
          </div>
        </div>
      ) : null}
    </details>
  );
}
